module.exports = __webpack_public_path__ + "img/4-5.888a729b.svg";